export default __webpack_public_path__ + "static/media/consultar-manifestracao.76577807.svg";